import * as React from "react";
import { Container, Row, Col } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoffee, faPodcast } from "@fortawesome/free-solid-svg-icons";
import { stat } from "fs";
import { store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import TestimonialList from "./testimonialList";
import TestimonialDetail from "./testimonialDetail";
import { dashboardListConstants } from "../home";

class TestimonialPageComponent extends React.Component {
	state = {
		isView: false,
		page: "",
		id: -1,
		title: "",
	};
	constructor(props: any) {
		super(props);
		this.state = {
			isView: false,
			page: "",
			id: -1,
			title: "",
		};
		this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = new URLSearchParams(window.location.search)?.get("page");
		var tValue = tokenstr == null ? "" : tokenstr;
		var idstr = new URLSearchParams(window.location.search).get("id");
		var id = idstr == null ? -1 : parseInt(idstr);
		var codestr = new URLSearchParams(window.location.search).get("code");
		var codeValue = codestr == null ? "" : codestr;
		var pageValue =
			id >= 0 || (codeValue && codeValue != "") ? "detail" : tValue;
		this.setState({
			...stat,
			page: pageValue,
			id: id,
			code: codeValue,
			isView: pageValue == "" ? true : false,
		});

		var alertMessage = window.localStorage.getItem("alertMessage");
		if (alertMessage && alertMessage != "") {
			store.addNotification({
				title: "Success!",
				message: alertMessage,
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			window.localStorage.setItem("alertMessage", "");
		}

		document.title = `${
			pageValue === "" ? "Testimonials" : "Testimonial"
		} - Daily Audio Bible Administration`;
	}

	handleCallbackMethod(value) {
		this.setState({ title: value });
	}

	render() {
		const data = JSON.parse(window.localStorage.getItem('dashboardListData') || "[]");
		const testimonialData = data && data.find((item) => item.uniqueCode === dashboardListConstants.testimonial);
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							{this.state.page == "detail" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faPodcast} />
										<span data-testid="testimonialPageTitle">
											{" "}
											{testimonialData?.title ?? "Testimonial"} - Details
										</span>
									</h2>
									<hr />
									<TestimonialDetail
										callback={this.handleCallbackMethod}
										id={this.state.id}
									/>
								</div>
							)}
							{this.state.page == "" && this.state.isView && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faCoffee} />
										<span data-testid="testimonialPageTitle">
											{" "}
											{testimonialData?.title ?? "Testimonial"}
										</span>
									</h2>
									<hr />
									<TestimonialList />
								</div>
							)}
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default TestimonialPageComponent;
